import { getError } from "@/utils/helpers";
import MmainService from "@/services/fsmain/MmainService";

export const namespaced = true;

export const state = {
  statements: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_STATEMENTS(state, statements) {
    state.statements = statements;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getMains({ commit }) {
    commit("SET_LOADING", true);

    MmainService.getMains()
      .then((response) => {
        commit("SET_STATEMENTS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_STATEMENTS", []);
  },
};
export const getters = {
  statements: (state) => {
    return state.statements;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
